// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1MuxN","content":"Consent_content__3C4XL","footer":"Consent_footer__3lRxO"};